(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.DesktopIconSvg = mod.exports;
  }
})(this, function (exports, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var DesktopIcon = function DesktopIcon() {
    return _react2.default.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        xlink: "http://www.w3.org/1999/xlink",
        width: "56",
        height: "56",
        viewBox: "0 0 56 56"
      },
      _react2.default.createElement(
        "defs",
        null,
        _react2.default.createElement("circle", { id: "a", cx: "28", cy: "28", r: "28" })
      ),
      _react2.default.createElement(
        "g",
        { fill: "none", fillRule: "evenodd" },
        _react2.default.createElement(
          "mask",
          { id: "b", fill: "#fff" },
          _react2.default.createElement("use", { href: "#a" })
        ),
        _react2.default.createElement("use", { fill: "#DFE1E7", href: "#a" }),
        _react2.default.createElement("rect", {
          width: "18.667",
          height: "2.074",
          x: "18.667",
          y: "31.148",
          fill: "#2D344B",
          mask: "url(#b)",
          rx: "1",
          transform: "rotate(-90 28 32.185)"
        }),
        _react2.default.createElement("rect", {
          width: "34.222",
          height: "22.815",
          x: "11.407",
          y: "15.519",
          fill: "#757D99",
          mask: "url(#b)",
          rx: "1"
        }),
        _react2.default.createElement("rect", {
          width: "34.222",
          height: "3.111",
          x: "11.407",
          y: "15.519",
          fill: "#47506B",
          mask: "url(#b)",
          rx: "1"
        }),
        _react2.default.createElement("rect", {
          width: "24.889",
          height: "1.037",
          x: "16.593",
          y: "22.907",
          fill: "#FFF",
          mask: "url(#b)",
          rx: ".519"
        }),
        _react2.default.createElement("rect", {
          width: "13.481",
          height: "1.037",
          x: "16.593",
          y: "26.148",
          fill: "#FFF",
          mask: "url(#b)",
          rx: ".519"
        }),
        _react2.default.createElement(
          "g",
          { fill: "#FFF", mask: "url(#b)" },
          _react2.default.createElement(
            "g",
            { transform: "translate(33 27)" },
            _react2.default.createElement("rect", {
              width: "7.254",
              height: "1.037",
              x: "1.627",
              y: "2.685",
              rx: ".519",
              transform: "rotate(-47 5.254 3.204)"
            }),
            _react2.default.createElement("rect", {
              width: "4.099",
              height: "1.037",
              x: "-.272",
              y: "4.334",
              rx: ".519",
              transform: "rotate(-133 1.777 4.852)"
            })
          )
        ),
        _react2.default.createElement("rect", {
          width: "5.185",
          height: "1.037",
          x: "16.593",
          y: "30.278",
          fill: "#FFF",
          mask: "url(#b)",
          rx: ".519"
        }),
        _react2.default.createElement("rect", {
          width: "18.667",
          height: "2.074",
          x: "18.667",
          y: "40.481",
          fill: "#2D344B",
          mask: "url(#b)",
          rx: "1"
        })
      )
    );
  };

  exports.default = DesktopIcon;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Tabber/icons/DesktopIcon.svg.js
// module id = 2011
// module chunks = 1